import { PdPanel } from "./pd-panel-viewer/PdPanel.js";
//#region src/pd-panel-viewer/pd-panel.ts
var tag = "pd-panel";
if (!customElements.get(tag)) customElements.define(tag, PdPanel);
//#endregion
export { PdPanel };
